var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3042",
    "data-name": "Groupe 3042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.154,
    height: 16.858,
    viewBox: "0 0 16.154 16.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 16.154,
    height: 16.858,
    transform: "translate(0 0)",
    fill: "#cea95a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3044",
    "data-name": "Groupe 3044",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36731",
    "data-name": "Trac\\xE9 36731",
    d: "M5.725,2.816s-1.066-.968-3.811,1.89C-1.013,7.754.289,8.694.289,8.694a12.939,12.939,0,0,1,4.005,1.32,13.16,13.16,0,0,1,2,1.481s.49.359.884.072A11.169,11.169,0,0,0,9.093,9.546C9.25,9.2,8.566,8.513,8.068,7.729A19.1,19.1,0,0,1,5.725,2.816",
    transform: "translate(0 -2.15)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36732",
    "data-name": "Trac\\xE9 36732",
    d: "M6.944,41.806A22.88,22.88,0,0,0,3.705,39.75c-1.34-.621-3.208-1.5-3.291.17s.2,4.086,1.154,3.855A41.984,41.984,0,0,1,5.906,42.64c1.149-.185,1.369-.433,1.039-.834",
    transform: "translate(-0.324 -31.517)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36733",
    "data-name": "Trac\\xE9 36733",
    d: "M13.946,60.52c.635-.471.917-.757.928-.966a.4.4,0,0,0-.447-.4s-3.249.4-4.358,1.56,1.739,4.084,2.263,3.227.472-2.571,1.613-3.418",
    transform: "translate(-7.941 -47.853)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36734",
    "data-name": "Trac\\xE9 36734",
    d: "M27.965,66.567c-.345-.137-.845.353-1.427,1.765s-.294,2.459.747,2.355c.89-.089,1.385-.654,1.385-1.722,0-1.3-.361-2.261-.706-2.4",
    transform: "translate(-21.23 -53.836)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36735",
    "data-name": "Trac\\xE9 36735",
    d: "M35.284.047c-1.664.15-.711,1.981-.036,3.3A22.9,22.9,0,0,0,37.434,6.5c.413.314.653.084.791-1.072a41.952,41.952,0,0,1,.958-4.38c.192-.967-2.235-1.147-3.9-1",
    transform: "translate(-27.796 0)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36736",
    "data-name": "Trac\\xE9 36736",
    d: "M60.412,10.9c.835-.559-2.208-3.285-3.317-2.131s-1.381,4.417-1.381,4.417a.4.4,0,0,0,.422.43c.207-.019.482-.313.927-.966.8-1.174,2.515-1.192,3.349-1.751",
    transform: "translate(-45.073 -6.866)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36737",
    "data-name": "Trac\\xE9 36737",
    d: "M64.756,25.111c-1.387.638-1.857,1.158-1.705,1.5s1.122.662,2.425.608c1.067-.043,1.611-.561,1.664-1.454.061-1.044-1-1.289-2.383-.651",
    transform: "translate(-50.987 -20.032)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.694daaf6c1ccc3b82016b4449851bb16.svg";
export { ForwardRef as ReactComponent };